import _ from 'lodash';
import showAlert from './showAlert';

const PIC_TYPES = ['jpg', 'png', 'gif', 'jpeg', 'eps', 'cdr', 'ai', 'tiff', 'bmp'];

//  判断置顶文件是否为图片, 若不是 ''
export function ifPicSuffix(fileName: string | undefined) {
  let suffix;
  if (typeof fileName === 'string') {
    const temp = fileName.replace(/.+\./, '').toLowerCase();
    suffix = PIC_TYPES.find((item: any) => {
      return item === temp;
    });
  }
  return suffix;
}

export function beforeUploadSuccess(response: any, file: any) {
  // 兼容java接口
  if (_.isNil(response.res_code) && !_.isNil(response.code)) {
    response.res_code = response.code;
  }
  // 兼容java接口
  if (!response.res_msg && response.message) {
    response.res_msg = response.message;
  }

  const { res_code, res_msg } = response;
  const result: { shouldRemove?: boolean; errorMsg?: string } = {};
  if (res_code !== 1) {
    showAlert({ type: 'error', message: res_msg });
    result.shouldRemove = true;
  }
  return result;
}


